import { ReferenceAddress } from './types';
import { VIEW_NODE_ID_ATTR } from './consts';
import { CollapsedReferenceAddress as CollapsedReferenceAddresses } from './CollapsedReferenceAddresses';

type CollapsedReferenceAddressPopoverLabels = {
  groupTitle: string;
  hierarchyTitle: string;
};

const DEFAULT_LABELS: CollapsedReferenceAddressPopoverLabels = {
  groupTitle: 'Collapsed group depth',
  hierarchyTitle: 'Collapsed component hierarchy depth',
};

type CollapsedReferenceAddressPopoverArgs = {
  nodeAddressMap: Map<string, ReferenceAddress[]>;
  isUserDefinedGrouping: boolean;
  labels?: Partial<CollapsedReferenceAddressPopoverLabels>;
};
const collapsedReferenceAddressPopover =
  ({
    nodeAddressMap,
    isUserDefinedGrouping,
    labels,
  }: CollapsedReferenceAddressPopoverArgs) =>
  (element: Element | null) => {
    const viewNodeId = element?.getAttribute(VIEW_NODE_ID_ATTR);
    if (!viewNodeId) {
      return null;
    }
    const addresses = nodeAddressMap.get(viewNodeId);
    if (!addresses) {
      return null;
    }
    const visibleAddresses = addresses.map(address => {
      const firstHiddenIndex = address.findIndex(
        ({ nodeInfo: { isHidden } }) => isHidden
      );
      return address.slice(firstHiddenIndex - 1);
    });

    const resolvedLabels = { ...DEFAULT_LABELS, ...labels };
    return (
      <CollapsedReferenceAddresses
        addresses={visibleAddresses}
        title={
          isUserDefinedGrouping
            ? resolvedLabels.groupTitle
            : resolvedLabels.hierarchyTitle
        }
      />
    );
  };
export { collapsedReferenceAddressPopover };
